module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Lemire Lemire avocats","short_name":"LLA","start_url":"/","background_color":"#626861","theme_color":"#626861","display":"standalone","icon":"src/favicon.png","legacy":false,"cache_busting_mode":"query","include_favicon":true,"theme_color_in_head":true,"cacheDigest":"70a0406d099a1f29582a75b8416888ac"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-41947132-1","head":true},
    }]
